import { render } from "./PopupModal.vue?vue&type=template&id=1131aa84&scoped=true"
import script from "./PopupModal.vue?vue&type=script&scoped=true&lang=js"
export * from "./PopupModal.vue?vue&type=script&scoped=true&lang=js"

import "./PopupModal.vue?vue&type=style&index=0&id=1131aa84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1131aa84"

export default script